import { Clock } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatAsOf, isStale } from "./report-format";

/** "Data as of …" — every hours report shows when NOS was read, amber when over a day old. */
export function ReportFreshness({ dataAsOf }: { dataAsOf: string }) {
  const stale = isStale(dataAsOf);
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 text-xs",
        stale ? "text-warning-700" : "text-muted-foreground",
      )}
      title="When these hours were read from NOS. Refreshed at most every 5 minutes."
    >
      <Clock className="h-3.5 w-3.5" aria-hidden />
      Data as of {formatAsOf(dataAsOf)}
      {stale ? " — over a day old" : ""}
    </span>
  );
}
